import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MyInvoicesState } from '@store/states/my-invoices.state';

const myInvoicesSelector = createFeatureSelector<MyInvoicesState>('myInvoices');

export const myInvoicesSelectors = {
  listingDataDataSig: createSelector(myInvoicesSelector, (state) => state.listingData.data),
  listingDataFiltersSig: createSelector(myInvoicesSelector, (state) => state.listingData.filters),
  listingDataErrorSig: createSelector(myInvoicesSelector, (state) => state.listingData.error),
  requestList: createSelector(myInvoicesSelector, (state) => state.requestList.data),
  requestListError: createSelector(myInvoicesSelector, (state) => state.requestList.error),
  requestListFilter: createSelector(myInvoicesSelector, (state) => state.requestList.filter),
  requestListPage: createSelector(myInvoicesSelector, (state) => state.requestList.page),
  requestListSort: createSelector(myInvoicesSelector, (state) => state.requestList.sort),
};
